import { useGoogleLogin } from "@react-oauth/google";
// import { jwtDecode, JwtPayload } from "jwt-decode";
import { toAbsoluteUrl } from "../../helpers";

// interface GoogleTokenPayload extends JwtPayload {
//   sub: string;
//   given_name: string;
//   family_name: string;
//   name: string;
//   email: string;
// }

type Props = {
  onSuccess: (data: any) => void;
};

const LoginWithGoogle: React.FC<Props> = ({ onSuccess }) => {
  // const handleSuccess = (credentialResponse: CredentialResponse) => {
  //   if(credentialResponse && credentialResponse.credential) {
  //     const userDetails = jwtDecode<GoogleTokenPayload>(credentialResponse.credential);
  //     console.log("User Details:", userDetails);

  //     handleSocialLogin({
  //       store_id: storeId,
  //       cart_id: cartId,
  //       first_name: userDetails.given_name,
  //       last_name: userDetails.family_name,
  //       name: userDetails.name,
  //       email: userDetails.email,
  //       source: 'google',
  //       source_id: userDetails.sub,
  //     });
  //   }
  // };

  // const handleError = () => {};

  const login = useGoogleLogin({
    onSuccess: onSuccess,
    onError: () => {
      console.error("Google Login Failed");
    },
  });

  return (
    <>
      {/* <GoogleLogin
        logo_alignment="center"
        text="continue_with"
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap
        width={"100%"}
      /> */}
      <button
        className="google-login-btn"
        type="button"
        onClick={() => login()}
      >
        <img src={toAbsoluteUrl("images/google-logo.png")} alt="" />
        {/* <Google /> */}
        <span>Continue with Google</span>
      </button>
    </>
  );
};

export default LoginWithGoogle;
